import { useCallback } from 'react';
import type { VoidFunctionComponent } from 'react';

import { Category, IssueScopeKind } from '../../../../../shared/issuesV2';
import IssuesSection from '../../../shared/settings/SettingsPageIssueSection';
import Section from '../../../shared/settings/SettingsPageSection';
import SnippetScanningSettingsSection from '../../../shared/settings/SnippetScanningSettingsSection';

import type { IssueSettingsWithSnippetScanning } from './types';

/**
 * ProjectLicensingIssuesSettings
 */
const ProjectLicensingIssuesSettings: VoidFunctionComponent<IssueSettingsWithSnippetScanning> = ({
  isSnippetScanningEnabled,
  onToggleSnippetScanning,
  ...issuesSectionProps
}) => {
  const renderSnippetSettings = useCallback(
    ({ isScanningEnabled, canEditPolicy }: { isScanningEnabled: boolean; canEditPolicy: boolean }) => {
      return (
        <SnippetScanningSettingsSection
          isSnippetScanningEnabled={isSnippetScanningEnabled ?? false}
          onToggleSnippetScanning={(isChecked) => onToggleSnippetScanning?.(isChecked)}
          isScanningEnabled={isScanningEnabled}
          canEditPolicy={canEditPolicy}
          scanType="license"
        />
      );
    },
    [isSnippetScanningEnabled, onToggleSnippetScanning],
  );

  return (
    <Section>
      <Section.Left heading="Licensing">
        <Section.Paragraph>Configuration for licensing issues on this project.</Section.Paragraph>
      </Section.Left>
      <Section.Right>
        <IssuesSection
          category={Category.Licensing}
          scopeType={IssueScopeKind.Project}
          renderSnippetSettings={renderSnippetSettings}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...issuesSectionProps}
        />
      </Section.Right>
    </Section>
  );
};

export default ProjectLicensingIssuesSettings;
